import { types } from './transit-insights.types';
import { getDefaultTransitInsightsFilters } from './transit-insights.actions';

const initialState = getDefaultTransitInsightsFilters();

const transitInsightsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_TRANSIT_INSIGHTS_FILTERS:
            return {
                ...state,
                ...action.payload,
            };
        case types.SET_TRANSIT_INSIGHTS_ROUTE:
            return {
                ...state,
                route: action.payload,
                direction: '',
            };
        case types.SET_TRANSIT_INSIGHTS_DIRECTION:
            return {
                ...state,
                direction: action.payload,
            };
        case types.SET_TRANSIT_INSIGHTS_DATE_RANGE:
            return {
                ...state,
                ...action.payload,
                // Keep metric cards in sync when the filter-panel date preset changes.
                ...(action.payload.period ? { metricsPeriod: action.payload.period } : {}),
            };
        case types.SET_TRANSIT_INSIGHTS_SELECTED_METRICS:
            return {
                ...state,
                selectedMetrics: action.payload,
            };
        case types.RESET_TRANSIT_INSIGHTS_FILTERS:
            return {
                ...action.payload,
            };
        case types.SET_TRANSIT_INSIGHTS_METRICS_PERIOD:
            return {
                ...state,
                metricsPeriod: action.payload,
            };
        case types.SET_TRANSIT_INSIGHTS_CHART_DATA_SMOOTHING:
            return {
                ...state,
                chartDataSmoothing: action.payload,
            };
        default:
            return state;
    }
};

export default transitInsightsReducer;
